import {
  get,
  post,
  put,
  patch,
  del,
} from '@/utils/request';

const url = 'administrators';

export function index(data) {
  return get({
    url,
    data,
  });
}

export function getLoginRecords(data) {
  return get({
    url: `${url}/login-records`,
    data,
  });
}

export function getViewRecords(data) {
  return get({
    url: `${url}/view-records`,
    data,
  });
}

export function getCheckinListByStoreId(store_id) {
  return get({
    url: `${url}/checks`,
    data: { store_id },
  });
}

export function getSalaryByAdministratorId({ administrator_id, store_id }) {
  return get({
    url: `${url}/${administrator_id}/salaries`,
    data: { store_id },
  });
}

export function getIdByPhone({ phone, exclude_id }) {
  return get({
    url: `${url}/phones/${phone}`,
    data: { exclude_id },
  });
}

export function show(id) {
  return get({
    url: `${url}/${id}`,
  });
}

export function getEmploymentRecords(id) {
  return get({
    url: `${url}/${id}/employment-records`,
  });
}

export function getWeChatStatus(id) {
  return get({
    url: `${url}/${id}/wechat-status`,
  });
}

export function removeWeChat(id) {
  return del({
    url: `${url}/${id}/wechat`,
  });
}

// 补建企业微信成员并发送邀请（入职审核通过时企微接口失败的事后重试）
export function retryWeChatBind(id) {
  return post({
    url: `${url}/${id}/wechat-bind`,
  });
}

// 重新发送企业微信加入邀请
export function resendWeChatInvite(id) {
  return post({
    url: `${url}/${id}/wechat-invite`,
  });
}

export function getLoginRecordDetail(id) {
  return get({
    url: `${url}/login-records/${id}`,
  });
}

// 注册管理员
export function store(data) {
  return post({
    url,
    data,
  });
}

// 修改管理员个人资料
export function update(id, data) {
  return put({
    url: `${url}/${id}`,
    data,
  });
}

// 修改自己密码
export function updatePassword(data) {
  return patch({
    url: `${url}/passwords`,
    data,
  });
}

// 修改其他管理员密码
export function updatePasswordByAdministrator(id, data) {
  return patch({
    url: `${url}/${id}/passwords`,
    data,
  });
}


export function getSelfProfile() {
  return get({
    url: `${url}/self-profile`,
  });
}

export function updateSelfProfile(data) {
  return patch({
    url: `${url}/self-profile`,
    data,
  });
}

export function updatePasswordBySms(data) {
  return patch({
    url: `${url}/passwords/sms`,
    data,
  });
}

export function updatePasswordWithLog(data) {
  return patch({
    url: `${url}/passwords/self`,
    data,
  });
}

// 还原管理员
export function restore(id) {
  return patch({
    url: `${url}/${id}`,
  });
}

// 删除管理员（账号清理，仅超级管理员）
export function destroy(id, data) {
  return del({
    url: `${url}/${id}`,
    data,
  });
}

// 保存访问记录
export function storeViewRecord(data) {
  return post({
    url: `${url}/view-records`,
    data,
    isAutoShowErrorTip: false,
  });
}
